export default defineEventHandler((event) => {
  if (process.env.APP_ENV === "production") {
    const imagesExtensions = /\.(png|jpg|jpeg|gif|webp|svg)$/
    if (event.req.url.match(imagesExtensions)) {
      event.res.setHeader("Cache-Control", `max-age=86400`)
    }
  }
})
